export default __webpack_public_path__ + "static/media/calendar-icon.8040a729.svg";